import './MenuBottom.css';

import React, { Component } from 'react';

export class MenuBottom extends Component {
    static displayName = MenuBottom.name;
    state = {
        progress: false,
        isNavCollapsed: false,
    };

    handleNavCollapse = (e) => {
        this.setState({ isNavCollapsed: !this.state.isNavCollapsed })
    }

    render() {
        return (
            <>
                {this.menuBottom(this.onClickMenu)}
                <div id="footerCar" className="col-xl-4 col-md-4 col-sm-8 ">
                    <div id="groupMenuBottom " className="p-2"  >
                        <img src="/images/ImgMenuBottom.svg" id="imgMenuBottom"
                            onClick={(e) => this.showMenuBottom(e)} />
                        <span id="captionMenuBottom"
                            onClick={(e) => this.showMenuBottom(e)}>تنظیمات</span>
                    </div>
                    <div className="d-flex flex-row    " id="flexRow" >
                        <div className="flex-fill d-flex   justify-content-center">
                            <img
                                src="/images/logobottom.svg"
                                id="imgLogoBottom"
                                className=" justify-content-center"
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }

    onClickMenu = (e, id) => {
        e.preventDefault();
        this.setState({ isNavCollapsed: false });
        this.props.ClickMenu(id);
    }

    showMenuBottom = (e) => {
        e.preventDefault();
        //console.log('ff',this.state.isNavCollapsed);
        this.setState((prv) => ({ isNavCollapsed: !prv.isNavCollapsed }), () => {
            //console.log('ff',this.state.isNavCollapsed);
        });
    }
    hideMenu = (e) => {
        e.preventDefault();
        console.log('ff');
        this.setState({ isNavCollapsed: false });
    }
    menuBottom = (click) => {
        return (
            <>
                <div className={`${!this.state.isNavCollapsed ? 'offcanvas offcanvas-start' : 'offcanvas offcanvas-start show'}`}
                    style={{ visibility: this.state.isNavCollapsed ? 'visible' : 'hidden', right: 'auto' }}
                    tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel" >
                    <div className="offcanvas-header offcanvas-header  d-flex justify-content-end" >
                        <button type="button" className="btn text-reset" data-bs-dismiss="offcanvas"
                            id="btn-close"
                            onClick={(e) => { this.hideMenu(e) }}
                            aria-label="Close">
                            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#F4DF72'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z' /></svg>
                        </button>
                    </div>
                    <div className="d-flex justify-content-center" id="hrCanvas"  >

                    </div>
                    <div className="d-flex justify-content-center" id="logoCanvas"   >
                        <img src="images/logoCanvas.svg" />
                    </div>
                    <div className="d-flex justify-content-center" id="captionCanvas"   >
                        <span>ردیاب نورون</span>
                    </div>
                    <div className="list-group">
                        <a onClick={(e) => click(e, 18)} className="list-group-item list-group-item-action" >
                            <img src="images/menu/menuSamaneh1.svg" />
                            آموزش</a>
                        {/* <a onClick={(e) => click(e, 2)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuSamaneh1.svg" />
                            سامانه آنلاین 1</a>
                        <a onClick={(e) => click(e, 3)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuSamaneh2.svg" />
                            سامانه آنلاین 2</a>*/}
                        <a onClick={(e) => click(e, 4)} className="list-group-item list-group-item-action" >
                            <img src="images/menu/menuAddDevice.svg" />
                            افزودن ردیاب </a>
                        <a onClick={(e) => click(e, 5)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuAddUser.svg" />
                            افزودن کاربر</a>
                        <a onClick={(e) => click(e, 6)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuMoveDevice.svg" />
                            تغییر شماره مدیر </a>
                        {/*<a onClick={(e) => click(e, 7)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuManageSim.svg" />
        مدیریت سیم کارت ها</a>*/}
                        {/* <a onClick={(e) => click(e, 8)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuManagePassword.svg" />
    تنظیمات رمز</a>*/}
                        <a onClick={(e) => click(e, 9)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuMic.svg" />
                            حساسیت میکروفن</a>
                        <a onClick={(e) => click(e, 10)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuPermissionHear.svg" />
                            اجازه شنود کاربران</a>
                        <a onClick={(e) => click(e, 11)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuModeAlarm.svg" />
                            نوع هشدار</a>
                        <a onClick={(e) => click(e, 12)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuLockChild.svg" />
                            قفل کودک</a>
                        <a onClick={(e) => click(e, 13)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuFabrikControl.svg" />
                            کنترل فابریک</a>
                        <a onClick={(e) => click(e, 14)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuLockAuto.svg" />
                            قفل اتوماتیک</a>
                        <a onClick={(e) => click(e, 16)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuInternet.svg" />
                            اینترنت</a>
                        <a onClick={(e) => click(e, 17)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuSupport.svg" />
                            اعزام به تعمیرگاه</a>
                        <a onClick={(e) => click(e, 18)} className="list-group-item list-group-item-action">
                            <img src="images/menu/menuSupport.svg" />
                            کسب درآمد</a>
                    </div>


                </div>
            </>
        )
    }




}